import React from 'react'
import Modal from '../../../../components/modal/modal.component'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component'
import CreditCardsList from '../../../../components/credit-cards/credit-cards-list.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ClubService } from '../../../../services'
import { toastActions } from '../../../../actions'
import { StyledContent } from './styles/content.style'
import { bindActionCreators } from 'redux'
import { StyledPendingPayment } from './styles/pending-payment'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const PendingPayment = ({ billing }) => {
	const { dueDate, planName, lastFourDigits, value } = billing

	return (
		<StyledPendingPayment>
			<table>
				<tbody>
					<tr>
						<td>Data da cobrança</td>
						<td>{dueDate}</td>
					</tr>
					<tr>
						<td>Descrição</td>
						<td>{planName}</td>
					</tr>
					<tr>
						<td>Cartão de crédito</td>
						<td>**** **** **** {lastFourDigits}</td>
					</tr>
					<tr>
						<td>Valor</td>
						<td>{value}</td>
					</tr>
				</tbody>
			</table>
		</StyledPendingPayment>
	)
}

class RegularizePaymentPage extends React.Component {
	state = {
		modalIsOpen: false,
		billing: null
	}

	componentWillMount() {
		ClubService.getPendingBillingData().then(
			({ data: billing, success, errors }) => {
				success
					? this.setState({ billing })
					: this.props.danger({
						message: `Não foi possível buscar a cobrança: ${errors[0]}`
					})
			}
		)
	}

	onSubmit = () => {
		const {
			showLoading,
			hideLoading,
			danger,
			success,
			deviceId,
			cardId
		} = this.props

		showLoading()

		ClubService.regularizePendingBilling({
			deviceId,
			cardId
		})
			.then(data => {
				if (data.success) {
					this.setState({ modalIsOpen: false }, () => {
						this.props.history.push(
							`${routes.CLIENTE}/historico-de-pagamentos`
						)
						success({ message: 'Pagamento regularizado com sucesso!' })
					})
				} else {
					danger({
						message: `Não foi possível regularizar o pagamento: ${data.errors[0]
							}`
					})
				}

				hideLoading()
			})
			.catch(error => {
				danger({
					message: `Não foi possível regularizar o pagamento: ${error}`
				})
				hideLoading()
			})
	}

	render() {
		const { modalIsOpen, billing } = this.state

		return (
			<InnerPageContainer>
				<AntiFraud />
				<Title>Regularização de assinatura</Title>
				<h3 className="orange semi-bold">Pagamento pendente</h3>
				<StyledContent>
					{billing && <PendingPayment billing={billing} />}
					<CreditCardsList title="Selecione o cartão que deseja utilizar para o pagamento" />
				</StyledContent>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						marginTop: '4rem'
					}}>
					<Button
						primary
						onClick={() =>
							this.setState({
								modalIsOpen: true
							})
						}>
						Confirmar
					</Button>
				</div>

				<Modal
					ref="modal"
					isOpen={modalIsOpen}
					onClose={() =>
						this.setState({
							modalIsOpen: false
						})
					}>
					<p>Deseja regularizar a assinatura?</p>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center'
						}}>
						<Button
							secondary
							style={{ marginRight: '15px' }}
							type="button"
							onClick={() => this.refs.modal.close()}>
							Não
						</Button>
						<Button primary type="button" onClick={this.onSubmit}>
							Sim
						</Button>
					</div>
				</Modal>
			</InnerPageContainer>
		)
	}
}

const mapStateToProps = ({ antiFraud, creditCards }) => ({
	deviceId: antiFraud.sessionID,
	cardId: creditCards.creditCards.filter(card => card.main).length
		? creditCards.creditCards.filter(card => card.main)[0].id
		: null
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			success: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedRegularizePaymentPage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(RegularizePaymentPage)
)

export { connectedRegularizePaymentPage as ModuleRootComponent }
